import React, { useState, useCallback, useEffect } from "react";

import { MdClose } from "react-icons/md";

import {
  Container,
  FormContainer,
  FieldContainer,
  ModalStyle,
  ModalHeader,
  Title,
  ContainerButtons,
  SecondFieldContainer
} from "./styles";
import theme from "styles/theme";
import OutlinedButton from "components/layout/form/outlinedButton";
import ContainedButton from "components/layout/form/containedButton";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from "components/layout/form/textField";
import { toast } from "react-toastify";
import { GoLocation } from "react-icons/go";
import api from "services/api";
import TextSelect from "components/layout/form/TextSelect";
import { getAddressZipCode } from "../services";
import axios from "axios";

const statesLst = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO"
];
function MailingAddress({ openModal, modalFunction, setAddressShipLetterTo }) {
  const [loading, setLoading] = useState();
  const [lastZipCode, setLastZipCode] = useState();
  const [access_token, setAccessToken] = useState();
  const [disabledCity, setDisabledCity] = useState(false);
  const [disabledUF, setDisabledUF] = useState(false);

  useEffect(() => {
    setLastZipCode(false);
  },[openModal])

  const validationSchema = () =>
    Yup.object().shape({
      zipCode: Yup.string()
        .matches(/[0-9]{5}-[0-9]{3}/, "Insira um cep válido")
        .required("É necessário digitar um cep"),
      address: Yup.string().required("É necessário digitar um logradouro"),
      number: Yup.string().required("  "),
      neighborhood: Yup.string().required("É necessário digitar um bairro"),
      city: Yup.string().required("É necessário digitar uma cidade"),
      stateCode: Yup.string().required("  ")
    });

  const requestGetAddress = useCallback(
    (zipcode, setFieldValue, handleChange, e) => {
      setLoading(true);
      const headers = {
        access_token
      };
      const params = {
        "zip-code": zipcode
      };

      api
        .get(`locality/v1/places`, {
          headers,
          params
        })
        .then(response => {
          setLoading(false);
          const { data } = response;
          if(data && data.length > 0) {
            const reqAddress = data[0];
            setFieldValue("address", reqAddress.address);
            setFieldValue("neighborhood", reqAddress.neighborhood);
            setFieldValue("city", reqAddress.city);
            setFieldValue("stateCode", reqAddress.stateAbbreviation);

          }
        })
        .catch(err => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const message = err.response.data.message;
            if (err.response.status !== 401) {
              toast.error(message || "Ocorreu um erro interno na aplicação");
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        });
    },
    [api, setLoading, toast, access_token]
  );

  const handleSubmit = useCallback(
    values => {
      setAddressShipLetterTo({
        fullAddress: `${values.address} - ${values.neighborhood}, ${values.city} - ${values.stateCode}, ${values.zipCode}`,
        zipCode: values.zipCode || "",
        address: values.address || "",
        number: values.number || "",
        complement: values.complement || "",
        neighborhood: values.neighborhood || "",
        city: values.city || "",
        stateCode: values.stateCode || "",
        addressType: "SHIP_TO"
      });
      modalFunction(false);
    },
    [loading, modalFunction, setAddressShipLetterTo]
  );

  const handleChangeCep = useCallback(
    async (e, handleChange, setFieldValue, resetForm) => {
      handleChange(e);
      if(!e.target.value) {
        resetForm();
      }
      const zipcode = e.target.value.replace(/[^\d]/g, "");
      if (zipcode.length >= 8 && zipcode !== lastZipCode) {
        setDisabledCity(false);
        setDisabledUF(false);
        setLastZipCode(zipcode);
        const [addressResponse] = await getAddressZipCode(zipcode);
        if(!addressResponse) {
          setDisabledCity(false);
          setDisabledUF(false);
          toast.warn('O CEP digitado parece inválido, não encontramos nenhuma informação! Caso esteja correto, preencha manualmente as informações.')
        }
        if(addressResponse?.address) {
          setFieldValue("address", addressResponse?.address);
        }
        if(addressResponse?.neighborhood) {
          setFieldValue("neighborhood", addressResponse?.neighborhood);
        }
        if(addressResponse?.city) {
          setFieldValue("city", addressResponse?.city);
          setDisabledCity(true);
        }
        if(addressResponse?.stateAbbreviation) {
          setFieldValue("stateCode", addressResponse?.stateAbbreviation);
          setDisabledUF(true);
        }
      }
    },
    [requestGetAddress, setLastZipCode, lastZipCode]
  );

  const requestGetAccessToken = useCallback(async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      grant_type: "client_credentials",
    };
    let response = "";
    try {
      response = await req.post("oauth/access-token", body, parameters);
      setAccessToken(response.data.access_token);
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }

    return response.data;
  }, [setAccessToken]);


  useEffect(() => {
    const request = async() => {
      await requestGetAccessToken();
    }
    request();
  },[]);


  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Editar endereço de correspondência</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Formik
          initialValues={{
            zipCode: "",
            address: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            stateCode: ""
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          render={({
            handleChange,
            handleBlur,
            setFieldValue,
            resetForm,
            values,
            errors,
            touched
          }) => (
            <FormContainer>
              <FieldContainer>
                <div>
                  <TextField
                    label="Digite seu CEP *"
                    name="zipCode"
                    type="text"
                    mask={"99999-999"}
                    value={values.zipCode}
                    onChange={e =>
                      handleChangeCep(e, handleChange, setFieldValue, resetForm)
                    }
                    onBlur={handleBlur}
                    errorCondition={errors.zipCode && touched.zipCode}
                    errorMessage={errors.zipCode}
                    LeadingIcon={() => <GoLocation size={24} />}
                  />
                </div>
              </FieldContainer>

              <FieldContainer>
                <div>
                  <TextField
                    label="Logradouro *"
                    name="address"
                    type="text"
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.address && touched.address}
                    errorMessage={errors.address}
                  />
                </div>
                <SecondFieldContainer>
                  <TextField
                    label="Número *"
                    name="number"
                    type="text"
                    value={values.number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.number && touched.number}
                    errorMessage={errors.number}
                  />
                </SecondFieldContainer>
              </FieldContainer>

              <FieldContainer>
                <div>
                  <TextField
                    label="Complemento"
                    name="complement"
                    type="text"
                    value={values.complement}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.complement && touched.complement}
                    errorMessage={errors.complement}
                  />
                </div>
              </FieldContainer>

              <FieldContainer>
                <div>
                  <TextField
                    label="Bairro *"
                    name="neighborhood"
                    type="text"
                    value={values.neighborhood}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.neighborhood && touched.neighborhood}
                    errorMessage={errors.neighborhood}
                  />
                </div>
              </FieldContainer>

              <FieldContainer>
                <div>
                  <TextField
                    label="Cidade *"
                    name="city"
                    type="text"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.city && touched.city}
                    errorMessage={errors.city}
                    disabled={disabledCity}
                  />
                </div>
                <SecondFieldContainer>
                  <TextSelect
                    label="UF *"
                    name="stateCode"
                    type="text"
                    value={values.stateCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorCondition={errors.stateCode && touched.stateCode}
                    errorMessage={errors.stateCode}
                    disabled={disabledUF}
                  >
                    <option value="" disabled defaultValue></option>
                    {statesLst.map((state, index) => (
                      <option key={index} value={state} selected={values.stateCode === state}>
                        {state}
                      </option>
                    ))}
                  </TextSelect>
                </SecondFieldContainer>
              </FieldContainer>
              <ContainerButtons>
                <OutlinedButton
                  color={theme.colors.purple}
                  onClick={() => modalFunction(false)}
                >
                  Cancelar
                </OutlinedButton>
                <ContainedButton type="submit" loading={loading}>
                  Adicionar
                </ContainedButton>
              </ContainerButtons>
            </FormContainer>
          )}
        />
      </Container>
    </ModalStyle>
  );
}

export default MailingAddress;
